module.exports = __webpack_public_path__ + "img/horizontal-flip.f8224b87.svg";